import script from "./ReviewList.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewList.vue?vue&type=script&setup=true&lang=js"

import "./ReviewList.vue?vue&type=style&index=0&id=2b7ebc21&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b7ebc21"]])

export default __exports__